import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { ThumbsUpIcon as ThumbsUpSvgIcon } from "Components/_Shared/Icons/Icons";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { FC } from "react";

type Props = {
  readonly backgroundColor: string;
  readonly error?: boolean;
};

const StyledContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.theme.spacing(Spacing.XXXL)};
  height: ${(props) => props.theme.spacing(Spacing.XXXL)};
  border-radius: ${(props) => props.theme.spacing(Radius.MAX)};
`;

export const ThumbsUpIcon: FC<Props> = ({ backgroundColor, error }) => {
  return (
    <StyledContainer
      sx={{
        transform: error ? "scaleY(-1)" : undefined,
        backgroundColor,
      }}
    >
      <ThumbsUpSvgIcon sx={{ color: "common.white" }} />
    </StyledContainer>
  );
};
